import React from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '@navigation/Breadcrumbs';
import { Input, FormBackground, FormContainer, ButtonsContainer, Button } from '@components/Forms';
import { Text, HiddenMobile } from '@components';
import { Hidden } from '@material-ui/core';

import { useForm, useUser } from '@hooks';
import { useHistory } from 'react-router-dom';

const UserDocumentNumberEdit = ({ route }) => {
  const {
    update,
    // eslint-disable-next-line camelcase
    selected: { doc_number },
  } = useUser({ fetchUsers: false });
  const { t } = useTranslation();
  const history = useHistory();
  const { formValues, handleInputChange, isValid, errors, isInitial } = useForm({
    doc_number,
  });

  const handleSubmit = () => {
    if (!isValid()) return '';
    update(formValues);
  };

  return (
    <>
      <Hidden mdDown>
        <Breadcrumbs route={route} />
      </Hidden>
      <FormBackground>
        <FormContainer>
          <HiddenMobile>
            <Text type="H6-w400" color="gray800">
              {t('editDocumentNumber.subtitle')}
            </Text>
          </HiddenMobile>
          <Input
            id="doc_number"
            testId="doc_number-testId"
            label={t('editDocumentNumber.document_type')}
            value={formValues.doc_number}
            onChange={handleInputChange}
            error={!!errors.doc_number}
            caption={errors.doc_number}
          />
          <ButtonsContainer>
            <HiddenMobile>
              <Button
                type="outlined"
                id="btn-cancel"
                testId="btn-cancel-testId"
                onClick={() => history.goBack()}
              >
                {t('common.buttonCancel')}
              </Button>
            </HiddenMobile>
            <Button
              id="btn-submit"
              testId="btn-submit-testId"
              onClick={handleSubmit}
              disabled={isInitial()}
            >
              {t('editDocumentNumber.submitbutton')}
            </Button>
          </ButtonsContainer>
        </FormContainer>
      </FormBackground>
    </>
  );
};

export default UserDocumentNumberEdit;
